<template>
	<div>
		<v-combobox
		v-model="selected_agent"
		:items="agent_list"
		item-text="agent_name"
		item-value="id"
		:label="label"
		:placeholder="label"
		@focus="getPickupAgents"
		@keydown="getPickupAgents"
		@change="updateAgent"
		:search-input.sync="agent_serch_query"
		append-icon="mdi-menu-down"
		single-line
		outlined
		clearable
		dense
		:rules="rules"
		:loading="loading"
		>
		<template v-slot:item="data">
			<v-list-item-content>
				<v-list-item-title v-html="data.item.agent_name"></v-list-item-title>
				<v-list-item-subtitle v-if="data.item.agent_phone_number" >{{$lang.MOBILE_PREFIX}}{{data.item.agent_phone_number}}</v-list-item-subtitle>
			</v-list-item-content>
		</template>

	</v-combobox> 		
</div>
</template>
<script type="text/javascript">

export default {
	props:{
		add_self: {
			type: Boolean,
			default:false,
		},
		agent_type:{
			type: String,
		},
		label:{
			type: String,
		},
		rules:{

		}
	},
	// props:['agent_type',"label"],
	data () {
		return {
			loading:false,	
			agent_list:[],
			agent_serch_query:"",
			selected_agent:null
		}
	},
	methods:{
		/* return the selected agent*/ 
		updateAgent(){
			this.$emit("update-pickup-agent",this.selected_agent);
		},
		/* get the agent list*/ 
		getPickupAgents(){
			const self=this
			self.filter_agent_type=status
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.search_query,
				list_type:"dropdown",
				filter_agent_type:JSON.stringify([self.agent_type]),
        is_active:'yes'
			};
			self.loading=true;
			const successHandler = (response) => {
				self.agent_list=response.data.agent_list
			};
			const finallyHandler = () => {
				self.loading=false
			};
			self.request_GET( self,self.$urls.AGENT_LIST,params,successHandler,null,null,finallyHandler,true)
		},
	}
}
</script>